import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyBUdatDAqXNTJfdH49fzI6hZPHAt2qyXWU",
  appId: "1:801274793163:web:e80ec3680bbc21c3521f4e",
  messagingSenderId: "801274793163",
  projectId: "kithub-b3297",
  authDomain: "kithub-b3297.firebaseapp.com",
  storageBucket: "kithub-b3297.firebasestorage.app",
  measurementId: "G-WBPVZSTC51",
});
export const firebaseAuth = getAuth(app);
